module.exports = __webpack_public_path__ + "assets/img/gift-8-d-ee536347.png";